import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { Conversation } from '../../../services/conversation';
import { PermissionDeniedDialogComponent } from '../../permission-denied-dialog.component';
import { AuthService } from '../../../services/auth';


@Component({
  selector: 'app-conversation-explorer',
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatTableModule, MatPaginatorModule,
    MatSortModule, MatInputModule, MatFormFieldModule, MatButtonModule,
    MatIconModule, MatTooltipModule, MatChipsModule,MatDatepickerModule
  ],
  templateUrl: './conversation-explorer.component.html',
styleUrls: ['./conversation-explorer.component.scss']

})
export class ConversationExplorerComponent implements OnInit {
    @Input() globalStartDate!: Date;
@Input() globalEndDate!: Date;
  displayedColumns: string[] = ['conversation_id', 'categories', 'outcomes', 'total', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  
  startDate = new Date();
  endDate = new Date();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  user;

  constructor(private authService: AuthService,private router: Router,private conversationService: Conversation,private dialog: MatDialog) {
    this.startDate.setDate(this.endDate.getDate() - 7);
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['globalStartDate'] || changes['globalEndDate']) {
    this.startDate = this.globalStartDate;
    this.endDate = this.globalEndDate;
    this.loadData(); // Your existing fetch/load function
  }
}

  loadData() {
    const start = this.startDate.toISOString().split('T')[0];
    const end = this.endDate.toISOString().split('T')[0];

    this.conversationService.getConversationExplorer(start, end).subscribe(res => {
      this.dataSource.data = res.data;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

     this.authService.user$.subscribe(user=>{
    if(user){
      this.user = user;
    }
   })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadCSV() {
    const data = this.dataSource.filteredData;
    const headers = ['ID', 'Unique Categories', 'Satisfied', 'Not Satisfied', 'Total Interactions'];
    const csv = [
      headers.join(','),
      ...data.map(r => `${r.conversation_id},${r.unique_categories},${r.satisfied_count},${r.not_satisfied_count},${r.total_interactions}`)
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `conversation_explorer_export.csv`;
    a.click();
  }

  async viewTranscript(conversationId: string) {
    console.log('Navigating to transcript for:', conversationId);
    // Add router navigation here: this.router.navigate(['/transcript', id]);
      const tokenResult = await this.user.getIdTokenResult();
        const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
        // console.log(tokenResult.claims)
         if (!allowView) {
            // Show modal
            const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
              width: '400px',
              disableClose: true, // Prevent escape/click-out
              autoFocus: true
            });
    
            // Wait for user to click OK
            await dialogRef.afterClosed().toPromise();
    
          } else {
             this.router.navigate(['/conversation', conversationId]);
          }
  }
}